<template>
  <!-- 3d 模型 -->
  <div class="model3d" id="container" ref="model3d">
    <!-- vox 模型 -->
    <template v-if="url.includes(`.vox`) && show_model">
      <!-- <vox-viewer 
          :src="url" 
          camera-controls
          shadow-intensity="0.3"
          background-color="#252628"
          style="height:100%;width:100%;"
      ></vox-viewer> -->
    </template>

    <!-- obj 模型 -->
    <template v-else-if="url.includes(`.obj`) && show_model">
      <model-obj
        v-if="show_obj_only"
        :src="url"
        gammaOutput

        :backgroundColor="backgroundColor"
        :cameraPosition="cameraPosition"
        :cameraRotation="cameraRotation"
        :scale="scale"
        :position="position"
        :rotation="rotation"
        :lights="lights"
        @on-load="onLoadModel" 
        @on-progress="onProgressModel"
        @on-error="onErrorModel" >
      </model-obj>
      
      <model-obj
        v-else
        :src="url"
        :mtl="get_mtl"
        
        :backgroundColor="backgroundColor"
        :cameraPosition="cameraPosition"
        :cameraRotation="cameraRotation"
        :scale="scale"
        :position="position"
        :rotation="rotation"
        :lights="lights"
        @on-load="onLoadModel" 
        @on-progress="onProgressModel"
        @on-error="onErrorModel" >
      </model-obj>

      <!-- 进度视图 -->
      <div :class="`progressShadow ${progress.percent === 100 ? 'hide':''}`">
        <!-- <span class="text" >{{progress.error ? progress.error:progress.percent+"%"}}</span> -->
        <span>loading...</span>
      </div>
    </template>

    <!-- 等待加载中 -->
    <div class="progressShadow" v-if="!show_model">
      <span class="text">等待加载中</span>
    </div>
  </div>
</template>
<script>

import { ModelObj, ModelThree, ModelCollada, ModelStl, ModelPly  } from 'vue-3d-model';
// obj	<model-obj>，json	<model-three>，stl	<model-stl> ， dae	<model-collada>， ply	<model-ply>， gltf(2.0)	<model-gltf>

export default {
  name: "Model3D",
  components: {
    ModelObj,
    ModelThree,
    ModelCollada,
    ModelStl,
    ModelPly
  },
  props: {
    url:{
      type:String,
      default:""
    }
  },
  data() {
    return {
      progress:{
        show:false,
        percent: 0,
        error: ""
      },
      show_model: false,
      show_obj_only: false,

      backgroundColor: '#ffffff', //#535353
      cameraPosition: { x: 0, y: 0, z: 0 }, //{0,0,0}
      cameraRotation: { x: 0, y: 0, z: 0 },
      scale: {x:1, y:1, z:1},
      controlsOptions:{autoRotate:true},
      // z 调整正视图距离，x 左侧视图距离，y 俯视图距离, 负数拉远，正数拉近
      position:{x:0,y:0,z:0},
      // z(正视图):正数(逆时针旋转) y(底视图):正数(逆时针旋转)
      rotation:{x:0,y:0,z:0},
      // 光照
      lights:  [
        {
          // 半球光
          type: 'HemisphereLight',
          // 光源在场景中的位置
          position: { x: 5, y: 50, z: 50 },
          // 天空发出的光线颜色 0xaaaaff
          skyColor: '#ffffff',
          // 地面发出的光线颜色 0x806060
          groundColor: '#ffffff',
          // 光源照射强度
          intensity: 0.6,
          // 光源是否打开
          // visible: false
        },
        {
          // 方向光
          type: 'DirectionalLight',
          position: { x: 50, y: 50, z: 50 },
          color: '#ffffff',  //0xffffff
          intensity: 0.6,
        },
      ]
    };
  },
  computed: {
    get_mtl(){
      return this.url.split(".obj")[0] + ".mtl"
    }
  },

  methods: {
    // ----------3d 模型事件
    onLoadModel(e){
      // console.log("onload_model:", e)
    },
    onProgressModel(e){
      // console.log("onprogress_model:")
      if(e.lengthComputable){
        this.progress.show = true
        let percent = parseInt(e.loaded / e.total) * 100;
        this.progress.percent = percent
        if(percent === 100){
          this.backgroundColor = '#252628'
        }
      }
      // console.log(percent);
    },
    onErrorModel(e){
      // console.log("onerror_model:", e, e.currentTarget.responseURL+e.currentTarget.responseText)
      if(e.currentTarget.responseURL.includes(".mtl") && e.currentTarget.status===404){
        // 只展示obj
        this.show_obj_only = true
      }else{
        this.show_obj_only = false
        this.progress.show = true
        this.progress.error = "加载出错"
      }
    },

    dealScroll(){
      let scrollHeight = document.documentElement.scrollHeight;
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      let clientHeight = document.documentElement.clientHeight;

      // document.getElementsByClassName("model3d")[0].offsetParent.offsetParent.offsetTop
      // let post_offset_top = document.getElementsByClassName("model3d")[0].offsetParent.offsetParent.offsetTop;
      let current_offset_top = this.$refs.model3d.offsetTop;
      let current_offset_height = this.$refs.model3d.offsetHeight;
      let post_offset_top1 = this.$refs.model3d.offsetParent.offsetParent.offsetTop;
      
      let currentTop = current_offset_top + post_offset_top1
      // console.log(current_offset_top, post_offset_top1, this.url)
      // console.log(scrollTop, scrollHeight, clientHeight, this.url);
      if(currentTop >= scrollTop && currentTop + current_offset_height < scrollTop+clientHeight+1){
        // 展示 model
        // console.log("1111")
        this.show_model = true;
      }else{
        // 展示加载中
        // console.log("2222")
        this.show_model = false
      }
    }
  },
  created () {
    window.addEventListener("scroll", this.dealScroll);
  },
  beforeDestroy () {
    console.log("beforeDestroy")
  },
  destroyed () {
    window.removeEventListener("scroll", this.dealScroll);
  },
  mounted() {
  this.dealScroll()
  }
};
</script>

<style lang="less" scoped>
.model3d{
  width: 100%;
  height: 100%;
  position: relative;
  .progressShadow {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);

    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    
    &.hide{
      transform: scaleX(0);
      transition: transform 1s;
    }
    .text{
      color: #ffffff;
      font-size: 25px;
    }
  }
}
#model-viewer{
  outline: none;
}
</style>